import ToggleButton from '../ToggleButton.jsx';

const PanelToggleButton = ({ options, value, fullWidth, size, onChange, pill, centered, disabled, className, noWrap = false }) => {
  return <ToggleButton options={options} value={value} fullWidth={fullWidth} size={size} onChange={onChange} pill={pill} centered={centered} className={className} disabled={disabled} noWrap={noWrap} />;
};

export default PanelToggleButton;
